import { TableColumnMeta } from "ds/components/Table/types";
import { MAX_CELL_WIDTH } from "ds/components/Table/constants";

import { PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS } from "./types";

export const PERSONAL_SETTINGS_SPACES_TABLE_STORAGE_KEY = "personal-settings-spaces-table";

export const TABLE_COLUMNS: Record<TableColumnMeta["id"], TableColumnMeta> = {
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.SPACE]: {
    id: PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.SPACE,
    title: "Space",
    minWidth: 130,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.PERMISSIONS]: {
    id: PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.PERMISSIONS,
    title: "Permissions",
    minWidth: 170,
    defaultWidth: 350,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
  [PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.DESCRIPTION]: {
    id: PERSONAL_SETTINGS_SPACES_TABLE_COLUMNS.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};
